export default "__VITE_ASSET__puQLZJIc__"